module.exports = "/_next/static/images/xactly-8fa4b84d6bd926f0be5a90b9653ec1f4.png";